// The same invitation always loads the same scenery, including direct reloads.
const SCENES = [
  { id: 'centro', zone: 'Centro Histórico' },
  { id: 'norte', zone: 'Toluca' },
  { id: 'tollocan', zone: 'Toluca' },
  { id: 'ceu', zone: 'Paseo Colón' },
  { id: 'parque', zone: 'Toluca' },
];
function getChallengeScene(challengeId) {
  let hash = 0;
  for (const char of String(challengeId)) hash = (Math.imul(hash, 31) + char.charCodeAt(0)) >>> 0;
  return SCENES[hash % SCENES.length];
}
module.exports = { getChallengeScene };
